export interface CategoryPreview {
  images: string[];
}

export const CATEGORY_PREVIEWS: Record<string, CategoryPreview> = {
  'rts.womensFashion': {
    images: [
      'https://media.modalyst.co/cache/8f/fb/8ffb58fa03c1b8a52b3d0f0ce3b82ba4.jpg',
      'https://media.modalyst.co/cache/08/5a/085a97b27b23522d76dec27145f9a72d.jpg',
      'https://media.modalyst.co/cache/76/04/7604496e5eb81aea3955d46275eff106.jpg',
    ],
  },
  'rts.mensFashion': {
    images: [
      'https://media.modalyst.co/cache/d5/83/d583a692876e12efa964fb951d446f30.jpg',
      'https://media.modalyst.co/cache/53/45/534592c59fe11ec07698865f27f5abf4.png',
      'https://media.modalyst.co/cache/6e/b0/6eb0a344dfdcad4cffae45226ec4d7c0.jpg',
    ],
  },
  'rts.beautyHealth': {
    images: [
      'https://media.modalyst.co/cache/22/71/22714f6fbde831c38be4df8fc108bc53.jpg',
      'https://media.modalyst.co/cache/75/5a/755ac8daf3f7c261fdd549fe9b282039.jpg',
      'https://media.modalyst.co/cache/c3/14/c314843234dae3c8c11baa044c2eea86.png',
    ],
  },
  'rts.jewelryAccessories': {
    images: [
      'https://media.modalyst.co/cache/de/71/de71c5bc14b8c97d348d0d5871fc315b.jpg',
      'https://media.modalyst.co/cache/e3/7c/e37ca83b175bb403410346b14a375741.jpg',
      'https://media.modalyst.co/cache/d6/41/d641f81c91e1221ec79afcf8ac685047.jpg',
    ],
  },
  'rts.consumerElectronics': {
    images: [
      'https://media.modalyst.co/cache/d4/f5/d4f57b382de4b1cef32c5b030a498753.jpg',
      'https://media.modalyst.co/cache/10/5a/105ad37d58c1c34f5ea76f968557233e.jpg',
      'https://media.modalyst.co/cache/4b/ab/4babc0a9d32adadc5ab3db4a064350d4.jpg',
    ],
  },
  'rts.homeGarden': {
    images: [
      'https://media.modalyst.co/cache/e3/60/e360313194ba7fda5c17dbdee6e8c9a6.jpg',
      'https://media.modalyst.co/cache/ef/5e/ef5e07515e3c9ebecf569a503c19728b.jpg',
      'https://media.modalyst.co/cache/9d/c2/9dc22ebe47f71dfd4adfa778701f4d1a.jpg',
    ],
  },
  'rts.kidsBabies': {
    images: [
      'https://media.modalyst.co/cache/2e/4d/2e4d0863aae3001edd52d1fdc9c43eb1.png',
      'https://media.modalyst.co/cache/11/94/119465f3def0feb349bfdd7678c425af.jpg',
      'https://media.modalyst.co/cache/9e/26/9e26115d2e8e4b0bd65dd3286fe033e5.jpg',
    ],
  },
  'rts.sportsEntertainment': {
    images: [
      'https://media.modalyst.co/cache/19/dd/19dd8ce199d4b0b9d84728c6fc1f9d89.jpg',
      'https://media.modalyst.co/cache/a4/0d/a40d722d9c090250e9071fbac216e939.jpg',
      'https://media.modalyst.co/cache/99/a7/99a7d47549fe11d6196a37acb90ebd8d.jpg',
    ],
  },
  'rts.bagsLuggage': {
    images: [
      'https://media.modalyst.co/cache/9a/2f/9a2f42db29a70c7b736e677fde690b7f.jpg',
      'https://media.modalyst.co/cache/50/15/5015c8c0e6f2f28de3091cc28f8a25ea.jpg',
      'https://media.modalyst.co/cache/c5/61/c5611df91f51624ed53abead15edf681.jpg',
    ],
  },
};
